import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseComponent } from "@tva/ng-migration/uicomponents/base/input-base.component";

@Component({
  selector: 'tva-radio',
  templateUrl: './tva-radio.component.html',
  styleUrls: ['./tva-radio.component.scss',],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TvActionRadioComponent,
    multi: true
  }]
})
export class TvActionRadioComponent extends InputBaseComponent {
  @Input() items: Array<any>;
  @Input() label: string;
  @Input() itemLabel: string;
  @Input() itemValue: string;

  constructor() {
    super();
  }

  getItemValue(item: any): any {
    if (this.itemValue) {
      return item[this.itemValue];
    }
    return item;
  }

  getItemLabel(item: any): any {
    if (this.itemLabel) {
      return item[this.itemLabel]
    }
    return item
  }
}
